import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UUIDName } from 'src/app/_core/models/GenericObject';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableDropdownComponent),
      multi: true,
    },
  ],
})
export class SearchableDropdownComponent implements OnInit {
  @Input() label: string = '';
  @Input() set options(value: any[]) {
    this.selectOptions = value;
    this.filteredOptions = this.selectOptions;
  }
  @Input() displayProperty: string = 'name';
  @Input() valueProperty: string = 'id';
  @Input() multipleSelection: boolean = true;
  @Input() formatMultiSelectedValues: boolean = false;
  @Input() disabled: boolean = false;
  @Output() selectionChange = new EventEmitter();

  searchControl = new FormControl('');
  filteredOptions: any[] = [];
  selectedValue: any = null;
  selectOptions: any[] = [];
  customizeDisplayValue: string;

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() {}

  ngOnInit(): void {
    this.filteredOptions = this.selectOptions;

    this.searchControl.valueChanges.subscribe((val) => {
      this.filterOptions(val);
    });
  }

  filterOptions(searchText: string = ''): void {
    const term = searchText.toLowerCase();
    this.filteredOptions = this.selectOptions.filter((option) => option[this.displayProperty].toLowerCase().includes(term));

    // Optionally: add back any selected values that are not in the filtered list
    if (this.multipleSelection && Array.isArray(this.selectedValue)) {
      const missingSelected = this.selectedValue.filter((selected: any) => !this.filteredOptions.some((o) => this.compareWithFn(o, selected)));
      this.filteredOptions = [...this.filteredOptions, ...missingSelected];
    }
  }

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelectionChange(value: any) {
    this.selectedValue = value;
    this.onChange(value);
    this.selectionChange.emit(value);
  }

  compareWithFn(o1: UUIDName, o2: UUIDName): boolean {
    return o1?.uuid === o2?.uuid || o1 === o2;
  }
}
